/**
 * @generated SignedSource<<774484cf98c53c40e4671e336aa0dfd2>>
 * @relayHash 08655b5a07a80d6db6123fa2b954538c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceBaseQueryBaseQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useSpaceBaseQueryBaseQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null | undefined;
      readonly homepage: {
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly icon: {
        readonly height: number | null | undefined;
        readonly isDefault: boolean | null | undefined;
        readonly path: string;
        readonly width: number | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly lookAndFeel: {
        readonly content: {
          readonly body: {
            readonly background: string | null | undefined;
            readonly backgroundAttachment: string | null | undefined;
            readonly backgroundBlendMode: string | null | undefined;
            readonly backgroundClip: string | null | undefined;
            readonly backgroundColor: string | null | undefined;
            readonly backgroundImage: string | null | undefined;
            readonly backgroundOrigin: string | null | undefined;
            readonly backgroundPosition: string | null | undefined;
            readonly backgroundRepeat: string | null | undefined;
            readonly backgroundSize: string | null | undefined;
            readonly borderRadius: string | null | undefined;
            readonly padding: string | null | undefined;
          } | null | undefined;
          readonly container: {
            readonly background: string | null | undefined;
            readonly backgroundAttachment: string | null | undefined;
            readonly backgroundBlendMode: string | null | undefined;
            readonly backgroundClip: string | null | undefined;
            readonly backgroundColor: string | null | undefined;
            readonly backgroundImage: string | null | undefined;
            readonly backgroundOrigin: string | null | undefined;
            readonly backgroundPosition: string | null | undefined;
            readonly backgroundRepeat: string | null | undefined;
            readonly backgroundSize: string | null | undefined;
            readonly borderRadius: string | null | undefined;
            readonly padding: string | null | undefined;
          } | null | undefined;
          readonly header: {
            readonly background: string | null | undefined;
            readonly backgroundAttachment: string | null | undefined;
            readonly backgroundBlendMode: string | null | undefined;
            readonly backgroundClip: string | null | undefined;
            readonly backgroundColor: string | null | undefined;
            readonly backgroundImage: string | null | undefined;
            readonly backgroundOrigin: string | null | undefined;
            readonly backgroundPosition: string | null | undefined;
            readonly backgroundRepeat: string | null | undefined;
            readonly backgroundSize: string | null | undefined;
            readonly borderRadius: string | null | undefined;
            readonly padding: string | null | undefined;
          } | null | undefined;
          readonly screen: {
            readonly background: string | null | undefined;
            readonly backgroundAttachment: string | null | undefined;
            readonly backgroundBlendMode: string | null | undefined;
            readonly backgroundClip: string | null | undefined;
            readonly backgroundColor: string | null | undefined;
            readonly backgroundImage: string | null | undefined;
            readonly backgroundOrigin: string | null | undefined;
            readonly backgroundPosition: string | null | undefined;
            readonly backgroundRepeat: string | null | undefined;
            readonly backgroundSize: string | null | undefined;
            readonly gutterBottom: string | null | undefined;
            readonly gutterLeft: string | null | undefined;
            readonly gutterRight: string | null | undefined;
            readonly gutterTop: string | null | undefined;
            readonly layer: {
              readonly background: string | null | undefined;
              readonly backgroundAttachment: string | null | undefined;
              readonly backgroundBlendMode: string | null | undefined;
              readonly backgroundClip: string | null | undefined;
              readonly backgroundColor: string | null | undefined;
              readonly backgroundImage: string | null | undefined;
              readonly backgroundOrigin: string | null | undefined;
              readonly backgroundPosition: string | null | undefined;
              readonly backgroundRepeat: string | null | undefined;
              readonly backgroundSize: string | null | undefined;
              readonly height: string | null | undefined;
              readonly width: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly header: {
          readonly backgroundColor: string | null | undefined;
          readonly button: {
            readonly backgroundColor: string | null | undefined;
            readonly color: string | null | undefined;
          } | null | undefined;
          readonly primaryNavigation: {
            readonly color: string | null | undefined;
            readonly hoverOrFocus: ReadonlyArray<{
              readonly key: string | null | undefined;
              readonly value: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly search: {
            readonly backgroundColor: string | null | undefined;
            readonly color: string | null | undefined;
          } | null | undefined;
          readonly secondaryNavigation: {
            readonly color: string | null | undefined;
            readonly hoverOrFocus: ReadonlyArray<{
              readonly key: string | null | undefined;
              readonly value: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly headings: ReadonlyArray<{
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined>;
        readonly menus: {
          readonly color: string | null | undefined;
          readonly hoverOrFocus: ReadonlyArray<{
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly metadata: {
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly name: string | null | undefined;
            readonly prefix: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
      readonly name: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly settings: {
        readonly routeOverrideEnabled: boolean | null | undefined;
      } | null | undefined;
      readonly theme: {
        readonly themeKey: string | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSpaceBaseQueryBaseQuery = {
  response: useSpaceBaseQueryBaseQuery$data;
  variables: useSpaceBaseQueryBaseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "width"
},
v5 = {
  "kind": "ScalarField",
  "name": "height"
},
v6 = [
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v7 = {
  "concreteType": "MapOfStringToString",
  "kind": "LinkedField",
  "name": "hoverOrFocus",
  "plural": true,
  "selections": (v6/*: any*/)
},
v8 = {
  "kind": "ScalarField",
  "name": "color"
},
v9 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v10 = [
  (v9/*: any*/),
  (v8/*: any*/)
],
v11 = [
  (v8/*: any*/),
  (v7/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "background"
},
v13 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v14 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v15 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v16 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v17 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v18 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v19 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v20 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v21 = [
  (v12/*: any*/),
  (v9/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  {
    "kind": "ScalarField",
    "name": "padding"
  },
  {
    "kind": "ScalarField",
    "name": "borderRadius"
  }
],
v22 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          (v3/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isDefault"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "SpaceSettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "routeOverrideEnabled"
              }
            ]
          },
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "themeKey"
              }
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v6/*: any*/)
              },
              {
                "concreteType": "MenusLookAndFeel",
                "kind": "LinkedField",
                "name": "menus",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ]
              },
              {
                "concreteType": "HeaderLookAndFeel",
                "kind": "LinkedField",
                "name": "header",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "concreteType": "ButtonLookAndFeel",
                    "kind": "LinkedField",
                    "name": "button",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  },
                  {
                    "concreteType": "NavigationLookAndFeel",
                    "kind": "LinkedField",
                    "name": "primaryNavigation",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  },
                  {
                    "concreteType": "NavigationLookAndFeel",
                    "kind": "LinkedField",
                    "name": "secondaryNavigation",
                    "plural": false,
                    "selections": (v11/*: any*/)
                  },
                  {
                    "concreteType": "SearchFieldLookAndFeel",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": (v10/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ScreenLookAndFeel",
                    "kind": "LinkedField",
                    "name": "screen",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v9/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "concreteType": "LayerScreenLookAndFeel",
                        "kind": "LinkedField",
                        "name": "layer",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v9/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "gutterTop"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "gutterRight"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "gutterBottom"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "gutterLeft"
                      }
                    ]
                  },
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": (v21/*: any*/)
                  },
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": (v21/*: any*/)
                  },
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": (v21/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "SpaceMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "prefix"
                      },
                      (v3/*: any*/),
                      (v1/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceBaseQueryBaseQuery",
    "selections": (v22/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceBaseQueryBaseQuery",
    "selections": (v22/*: any*/)
  },
  "params": {
    "cacheID": "08655b5a07a80d6db6123fa2b954538c",
    "id": "6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22",
    "metadata": {},
    "name": "useSpaceBaseQueryBaseQuery",
    "operationKind": "query",
    "text": "query useSpaceBaseQueryBaseQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id,key,alias,name,homepage{id},icon{path,width,height,isDefault},type,settings{routeOverrideEnabled},theme{themeKey},lookAndFeel{headings{key,value},menus{hoverOrFocus{key,value},color},header{backgroundColor,button{backgroundColor,color},primaryNavigation{color,hoverOrFocus{key,value}},secondaryNavigation{color,hoverOrFocus{key,value}},search{backgroundColor,color}},content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},header{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},body{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},metadata{labels{nodes{prefix,name,id}}},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "e885d5c349d4cf19afe686a9f6747925";

export default node;
